module.exports = __webpack_public_path__ + "img/slot-machine-trigger-up.d712e290.svg";